<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="nom">Nom du maîtrise</label>
          <input type="text" class="form-control" id="nom" v-model="maitrise.nom" maxlength="50" required>
        </div>

        <div class="form-group">
          <label for="prenom">Prénom du maîtrise</label>
          <input type="text" class="form-control" id="prenom" v-model="maitrise.prenom" maxlength="50" required>
        </div>

        <label for="arrondissement">Arrondissement de rattachement</label>
        <div v-for="(arr, value) in currentVille.arrondissements" v-bind:key="value">
          <div class="radio">
            <label>
              <input type="radio" name="arrondissement" v-bind:value="arr.id" v-model="maitrise.arrondissement_id"
                     required>
              {{ arr.nom }}
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="telephone">Numéro de téléphone</label>
          <input type="text" class="form-control" id="telephone" v-model="maitrise.telephone" pattern="^[0][0-9]{9}$"
                 oninvalid="this.setCustomValidity('Vous devez renseigner 10 caractères numériques et le premier doit être un 0')"
                 oninput="setCustomValidity('')" required>
        </div>
        <div v-if="maitriseToUpdate && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'ENVOI_SMS_A_PLUSIEURS_CONTACTS').actif">
          <label for="telephone">Liste des contacts</label>
          <div v-if="error" style="color:red;">Veuillez remplir tous les champs et respecter le format des champs</div>
          <div class="row" v-for="(input, index) in maitrise.contacts" :key="index">
            <div class="col-xs-3">
              <span class="title-item">Nom</span>
              <input v-model="input.nom" class="text-item text-disabled" type="text" maxlength="50">
            </div>
            <div class="col-xs-3">
              <span class="title-item">Prénom</span>
              <input v-model="input.prenom" class="text-item text-disabled" type="text" maxlength="50">
            </div>
            <div class="col-xs-3">
              <span class="title-item">Numéro</span>
              <input v-model="input.telephone" class="text-item text-disabled" type="text"
                     oninvalid="this.setCustomValidity('Vous devez renseigner 10 caractères numériques et le premier doit être un 0')"
                     oninput="setCustomValidity('')">
            </div>
            <div class="col-xs-3">
              <span class="title-item"><br/></span>
              <img :disabled="maitrise.contacts.length <= 1" class="text-item remove-input" type="button"
                   @click="removeInput(index)" src="../../../../static/img/dash-square.svg">
            </div>
          </div>
          <!-- </div> -->

          <img :disabled="maitrise.contacts.length === 10" class="text-item add-input" type="button" @click="addInput"
               src="../../../../static/img/plus-square.svg">
        </div>


        <div class="form-group">
          <label for="login">Email</label>
          <input type="email" class="form-control" id="email" v-model="maitrise.email"
                 v-bind:disabled="maitriseToUpdate" maxlength="50"
                 pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                 oninvalid="this.setCustomValidity('Vous devez renseigner une adresse email valide')"
                 oninput="setCustomValidity('')" required>
          <div class="invalid-feedback" v-if="emailExists" style="color: red;">
            Un maitrise avec le même email existe déjà dans la base de données !
          </div>
        </div>

        <div class="form-group">
          <label for="login">Login</label>
          <input type="text" class="form-control" id="login" v-model="maitrise.login" pattern=".{6,50}"
                 v-bind:disabled="maitriseToUpdate"
                 oninvalid="this.setCustomValidity('Vous devez renseigner au moins 6 caractères')"
                 oninput="setCustomValidity('')" required>
          <div class="invalid-feedback" v-if="loginExists" style="color: red;">
            Un maitrise avec le même login existe déjà dans la base de données !
          </div>
        </div>

        <div class="form-group" v-if="!maitriseToUpdate">
          <label for="password">Mot de passe</label>
          <input type="password" class="form-control" id="password" v-model="maitrise.password"
                 pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$"
                 v-bind:disabled="maitriseToUpdate" oninvalid="this.setCustomValidity('Le mot de passe doit contenir au moins 8 caractères, dont une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial.')"
                 oninput="setCustomValidity('')"
                 required>
        </div>

        <div class="form-group" v-if="maitriseToUpdate">
          <label for="password">Mot de passe</label>
          <input type="password" class="form-control" id="password" v-model="maitrise.password"
                 pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$"
                 v-bind:disabled="maitriseToUpdate" oninvalid="this.setCustomValidity('Le mot de passe doit contenir au moins 8 caractères, dont une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial.')"
                 oninput="setCustomValidity('')" >
        </div>
      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'currentVille',
      'currentUser',
      'adminUsers',
      'maitrises',
    ]),
  },
  props: [
    'maitriseToUpdate',
  ],
  data: function () {
    return {
      maitrise: (() => {
        if(this.maitriseToUpdate){
          const cloned = _.cloneDeep(this.maitriseToUpdate)
          if (!cloned.contacts || !Array.isArray(cloned.contacts)) {
            cloned.contacts = []
          }
          if (cloned.contacts.length === 0) {
            cloned.contacts.push({
              nom: '',
              prenom: '',
              telephone: '',
            })
          }
          console.log('maitrise data cloned ====>', cloned)
          return cloned
        }
        else{
          return {
            arrondissement_id: this.$store.state.currentVille.arrondissements[0].id,
            contacts:[]}
        }
        })(),
      envoi_sms_to_multiple_contacts: false,
      nomRegex: /[a-zA-Z]+/,
      telephoneRegex: /^[0][0-9]{9}$/,
      error: false,
      emailExists: false,
      loginExists: false,
      input: [],
    }
  },
  mounted () {
    this.$store.dispatch('fetchAllUsers');
    console.log("currenville",this.$store.state.currentVille.arrondissements[0].id)
    console.log("mait",this.maitrise)
  },
  methods: {
    isValidContactList(contacts) {
      this.error = false;

      const isValidFields = (contact) => {
        const allEmpty = contact.telephone === '' && contact.nom === '' && contact.prenom === '';
        const allFull = contact.telephone !== '' && contact.nom !== '' && contact.prenom !== '';
        return allEmpty || allFull;
      };

      const isValidContact = (contact) =>
        contact.telephone === '' && contact.nom === '' && contact.prenom === '' ||
        (this.nomRegex.test(contact.nom) &&
        this.nomRegex.test(contact.prenom) &&
        this.telephoneRegex.test(contact.telephone));

      if (contacts.length > 0){
        for (const contact of contacts) {
          if (!isValidFields(contact) || !isValidContact(contact)) {
            this.error = true;
            return false;
          }
        }
      }

      return true;
    },
    addInput: function () {
      this.maitrise.contacts.push({nom: '', prenom: '', telephone: ''})
    },
    removeInput: function (index) {
      this.maitrise.contacts.splice(index, 1)
    },
    confirm: function () {
      var self = this

      this.loginExists =  this.adminUsers.data.find(
        (maitrise) => maitrise.login === this.maitrise.login.trim() && maitrise.id !== this.maitrise.id
      )

      this.emailExists = this.adminUsers.data.find(
        (maitrise) => maitrise.email === this.maitrise.email.trim() && maitrise.id !== this.maitrise.id
      );

      if (this.maitriseToUpdate && this.isValidContactList(this.maitrise.contacts) && !this.emailExists && !this.loginExists){
        console.log("maitrise to update ==> ", this.maitrise)
        console.log("contacts to update ==> ", this.maitrise.contacts)
        //remove any empty contacts
        let newContacts = this.maitrise.contacts
          .filter(contact => contact.nom !== '' && contact.prenom !== '' && contact.telephone !== '')
          .map(contact => ({ ...contact,
            nom: contact.nom.trim(),
            prenom: contact.prenom.trim(),
            telephone: contact.telephone.trim(),
            maitrise_id: this.maitrise.id }));

        this.maitrise.contacts = newContacts

        console.log("contacts to update after empty removed ==> ", this.maitrise.contacts)
        this.$store.dispatch('updateMaitrise',this.maitrise).then(() => {
            self.$emit('close')
        })
      }
       else if (!this.maitriseToUpdate && !this.emailExists && !this.loginExists) {
        console.log('else')
        this.$store.dispatch('createMaitrise', this.maitrise).then(function () {
          self.$emit('close')
        })
      }
    },
  },
}
</script>
<style lang="scss">
.add-input {
  margin-left: 77.5%;
  margin-top: 3%;
}

img.remove-input, img.add-input {
  background-color: #aadc14;
}

.disable-click {
  pointer-events: none;
}

img[disabled] {
  cursor: not-allowed !important;
  pointer-events: none;
  opacity: 0.4;
}

.text-disabled[disabled] {
  cursor: not-allowed;
  opacity: 1;
  background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// MaitrisesForm.vue?21571c47